import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MODALITIES } from "@/lib/constants";

export const Modalities = () => (
  <section id="modalities" className="mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40" data-testid="modalities-section">
    <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue">On the recovery floor</p>
        <h2 className="font-display text-4xl font-black uppercase tracking-tighter md:text-6xl">
          Eight modalities.<br />Zero compromise.
        </h2>
      </div>
      <p className="max-w-sm text-sm leading-relaxed text-zinc-400 md:text-base">
        Heat, cold, light, pressure, oxygen and float — a complete recovery floor. Your complimentary Recovery
        Experience features 2–3 of these, selected around your goals.
      </p>
    </div>

    <div className="grid grid-cols-1 gap-5 md:grid-cols-8 lg:grid-cols-12 lg:auto-rows-[240px]">
      {MODALITIES.map((m, i) => (
        <motion.article
          key={m.name}
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
          className={`group relative min-h-[280px] overflow-hidden border border-white/10 ${m.span}`}
          data-testid={`modality-card-${m.name.toLowerCase().replace(/\s/g, "-")}`}
        >
          <img
            src={m.img}
            alt={`${m.name} at REST Recovery North Phoenix`}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
          <div className="absolute inset-0 border border-rest-red/0 transition-colors duration-500 group-hover:border-rest-red/50" />
          <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6">
            <div>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-1 font-display text-2xl font-black uppercase tracking-tighter">{m.name}</h3>
              <p className="mt-2 max-w-xs text-xs leading-relaxed text-zinc-300 md:text-sm">{m.tag}</p>
            </div>
            <ArrowUpRight className="h-5 w-5 shrink-0 text-white/50 transition-all duration-300 group-hover:text-rest-red" />
          </div>
        </motion.article>
      ))}
    </div>
  </section>
);
